module.exports = __webpack_public_path__ + "media/components/assets/icons/aside_arrow_r_light-e8d8258136c56d60335fc192b6190905.svg";